import { Input, Form, Modal, Typography } from "antd";
import { useState } from "react";

import { createItem, updateItem } from "@/api/positions";

const { Text } = Typography;

// Окно для создания/редактирования должности, содержит форму
const PositionModal = ({ data, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data) {
        await updateItem({ ...data, ...values });
      } else {
        await createItem(values);
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title={data ? "Редактирование должности" : "Добавление новой должности"}
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item
          name="name"
          label="Название"
          rules={[{ required: true, message: "Пожалуйста, введите название" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="description" label="Описание">
          <Input.TextArea rows={5} />
        </Form.Item>

        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default PositionModal;
